<template>
  <div id="app">
    <router-view :key="$route.name"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
  },

  created() {
  },

  watch: {
  }
};
</script>